import { Box } from '@mui/material';
import { DotLoading } from 'antd-mobile';
import React from 'react';

import { ObserverStore } from '@/component';

const MobileLoading = ObserverStore(() => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <DotLoading />
    </Box>
  );
});

export default MobileLoading;
